export default function getResponseMessage(slice: any) {
  return (state: any) => {
    return state.getIn([slice, 'data', 'msg']);
  };
}
